const DEFAULT_COMMENT_AUTHOR_NAME = "BongGo Learner";

export const getCommentAuthorDisplayName = (name?: string | null) => {
  const trimmedName = name?.trim();
  if (!trimmedName) return DEFAULT_COMMENT_AUTHOR_NAME;

  return trimmedName.split(/\s+/)[0] || DEFAULT_COMMENT_AUTHOR_NAME;
};
